export class Spinner extends HTMLElement {
    private template: HTMLTemplateElement;

    constructor() {
        super();
        this.template = document.createElement('template');
        this.attachShadow({ mode: 'open' });
        this.template.innerHTML = `
            <style>
                .container {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                svg {
                    width: 130px;
                    height: 130px;
                    flex: 0 0 130px;
                }
                @keyframes fade {
                    0% {opacity: .3;}
                    33.3% {opacity: .2;}
                    66.7% {opacity: .5;}
                    100% {opacity: .3;}
                }
                .fade {
                    animation: fade 1.5s infinite;
                }
                .rect-blue {
                    animation-delay: -1s;
                }
                .rect-orange {
                    animation-delay: -.5s;
                }
            </style>
            <div class="container">
                <svg viewBox="0 0 78.645 78.645">
                    <rect class="rect-yellow fade" width="21.234" height="36.963" fill="#ff7121"/>
                    <rect class="rect-blue fade" width="52.692" height="36.963" x="25.953" fill="#00acb5"/>
                    <rect class="rect-orange fade" width="78.644" height="36.963" y="41.682" fill="#faa900"/>
                </svg>
            </div>
        `;
    }

    connectedCallback() {
        this.shadowRoot.appendChild(this.template.content.cloneNode(true));
    }
}

window.customElements.define('spinner-element', Spinner);
